import { defineMessages } from 'react-intl';

import { ToastErrors } from './constants';
import type { ToolNames } from './types';

export const toolsMessages = defineMessages<ToolNames>({
  ruler: {
    id: 'toolName.ruler',
    defaultMessage: 'Ruler',
  },
  arrow: {
    id: 'toolName.arrow',
    defaultMessage: 'Arrow',
  },
  angle: {
    id: 'toolName.angle',
    defaultMessage: 'Angle',
  },
  eraser: {
    id: 'toolName.eraser',
    defaultMessage: 'Eraser',
  },
  view: {
    id: 'toolName.view',
    defaultMessage: 'View',
  },
  sharpening: {
    id: 'toolName.sharpening',
    defaultMessage: 'Sharpening',
  },
  expand: {
    id: 'toolName.expand',
    defaultMessage: 'Expand',
  },
  brightness: {
    id: 'toolName.brightness',
    defaultMessage: 'Brightness / Contrast',
  },
  sharpness: {
    id: 'toolName.sharpness',
    defaultMessage: 'Sharpness',
  },
  reset: {
    id: 'toolName.reset',
    defaultMessage: 'Reset',
  },
  invert: {
    id: 'toolName.invert',
    defaultMessage: 'Invert',
  },
  move: {
    id: 'toolName.move',
    defaultMessage: 'Move',
  },
  zoom: {
    id: 'toolName.zoom',
    defaultMessage: 'Zoom',
  },
  split: {
    id: 'toolName.split',
    defaultMessage: 'Split',
  },
  download: {
    id: 'toolName.download',
    defaultMessage: 'Download',
  },
  editNumbers: {
    id: 'toolName.editNumbers',
    defaultMessage: 'Edit tooth number',
  },
  editMask: {
    id: 'toolName.editMask',
    defaultMessage: 'Edit tooth contours',
  },
  ios: {
    id: 'toolName.ios',
    defaultMessage: 'Focus view',
  },
  turn: {
    id: 'toolName.rotateImage',
    defaultMessage: 'Rotate image',
  },
  hideMarks: {
    id: 'toolName.hideMarks',
    defaultMessage: 'Hide marks',
  },
});

// The id keeps its original dentalConsultation prefix on purpose: renaming it
// would orphan the translations this string already has in every locale.
export const evaluationMessages = defineMessages({
  accessRestricted: {
    id: 'dentalConsultation.evaluationAccessRestricted',
    defaultMessage:
      'The Evaluation tab is only available to the clinic owner and the user who ordered the report.',
  },
});

export const toastErrors = defineMessages<ToastErrors>({
  errorHeading: {
    id: 'error.heading',
    defaultMessage: 'Error',
  },
  wrongFormat: {
    id: 'error.heading.wrongFormat',
    defaultMessage: 'Wrong format',
  },
  defaultError: {
    id: 'global.defaultError',
    defaultMessage:
      'Something went wrong. Try again later or contact our support team.',
  },
});
